import { Box } from "@mui/material";

function BackgroundImageComponent({ imageUrl, children , lineargradient,height,padding }) {
  return (
    <Box
      sx={{
        height: height,
        position: "relative", 
        backgroundImage: lineargradient ?`${lineargradient}, 
                          url(${imageUrl})`:`url(${imageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        padding: { xs: "20px", sm: "40px", md: "60px 40px" },
        borderRadius:"40px"
      }}
    >
      {children}
    </Box>
  );
}

export default BackgroundImageComponent;
